import * as React from "react";

import api, { $ } from "kw/api";
import { quoteFields, riskProfileFields } from "kw/api/fragments";

import { jsonToCamelCase } from "kanopi-components/utils/json";
import { useGlobal } from "kanopi-components/useGlobal";
import { useTrackReferralRequired } from "./useTracking";

export const usePriceRiskProfile = () => {
  const [data = {}, setData] = useGlobal("quoting");
  const { quotes = [], reprice = false, pricingFailed, riskProfile } = data;
  const trackReferralRequired = useTrackReferralRequired({ referralType: "broker" });
  // We only set it to false after pricing is finished.
  const [initialPriceLoading, setInitialPriceLoading] = React.useState(
    !riskProfile?.periodicPrice
  );
  const [priceLoading, setPriceLoading] = React.useState(false);

  function priceRiskProfile() {
    setData({ reprice: true });
  }

  React.useEffect(() => {
    async function effect() {
      setPriceLoading(true);
      let response;
      try {
        response = await api.mutation(getPriceRiskProfileQuery(), {
          input: {
            riskProfileId: riskProfile?.id,
          },
        });
      } catch (e) {
        trackReferralRequired({
          referralReason: "Error",
          errors: e?.response?.errors || [e],
        });
        // Flag this in the global config so we can display a retry button appropriately
        setData({ pricingFailed: true });
      } finally {
        setInitialPriceLoading(false);
        setPriceLoading(false);
        setData({
          reprice: false,
        });
      }
      const periodicPrice = response?.priceRiskProfile?.periodicPrice;
      const paymentFrequency = response?.priceRiskProfile?.paymentFrequency;
      const quotes = response?.priceRiskProfile?.quotes || [];
      const riskData = response?.priceRiskProfile?.riskData
        ? JSON.parse(response?.priceRiskProfile?.riskData)
        : {};
      const _riskProfile = {
        ...response?.priceRiskProfile,
        data: jsonToCamelCase(riskData),
        riskData: jsonToCamelCase(riskData),
        periodicPrice,
        paymentFrequency,
      };
      setData({
        riskProfile: { ..._riskProfile },
        quotes,
      });
    }
    if (riskProfile?.id !== undefined && reprice === true) {
      effect();
    }
  }, [riskProfile?.id, reprice]);
  return [
    quotes,
    riskProfile,
    { priceRiskProfile, priceLoading, pricingFailed, initialPriceLoading },
  ];
};

function getPriceRiskProfileQuery() {
  // Do not fetch documents as they are generated asynchronously and priceRiskProfile
  // will not return latest documents.
  const quoteFieldsWithoutDocuments = { ...quoteFields };
  delete quoteFieldsWithoutDocuments.documents;
  return {
    priceRiskProfile: [
      {
        input: $("input", "RiskProfileInput!"),
      },
      {
        ...riskProfileFields,
        quotes: {
          ...quoteFieldsWithoutDocuments,
        },
      },
    ],
  };
}
